import { MAX_MESSAGE_LENGTH } from "../../constants";
import {
    Attachment,
    ComposeMessageEditorErrorType,
    ComposeStateType,
} from "../../reducer.types";
import { NHSAdviceLink } from "../../types";
import { calculateCharacterCount } from "../calculateCharacterCount";

/** Returns an error if the message length is invalid:
 * - If the message is to a mobile number and the characters
 *   exceed max length allowed
 * - If the message is left empty/untouched
 */
export const validatePatientMessageLength = ({
    messageBody,
    messageSignature,
    originalGreeting,
    originalSignature,
    withPatientResponseEnabled,
    withSelfBookLink,
    nhsAdviceLink,
    attachments,
    contactMethod,
    workspaceName,
    template,
}: {
    messageBody: string;
    messageSignature: string;
    originalGreeting: string;
    originalSignature: string;
    withPatientResponseEnabled: boolean;
    withSelfBookLink: boolean;
    nhsAdviceLink: NHSAdviceLink | null;
    attachments: Attachment[];
    contactMethod: ComposeStateType["contactDetails"]["method"];
    workspaceName: string;
    template: ComposeStateType["template"];
}): Pick<ComposeMessageEditorErrorType, "messageLength"> => {
    const { characterCount } = calculateCharacterCount({
        body: messageBody,
        footer: messageSignature,
        workspaceName,
        patientResponseEnabled: !!withPatientResponseEnabled,
        attachmentsCount: attachments.length,
        hasQuestionnaire: template.type === "QuestionnaireTemplate",
        nhsAdviceLink,
        hasSelfbookLink: withSelfBookLink,
    });

    const isBodyEmpty = messageBody.trim() === "";
    const isMessageEdited =
        `${messageBody.trim()}${messageSignature.trim()}` !==
        `${originalGreeting}${originalSignature}`;

    const hasBeenEdited =
        isMessageEdited ||
        withPatientResponseEnabled ||
        !!nhsAdviceLink ||
        attachments.length > 0;

    if (contactMethod === "Mobile" && characterCount > MAX_MESSAGE_LENGTH) {
        return { messageLength: "MESSAGE_TOO_LONG" };
    } else if (isBodyEmpty || !hasBeenEdited) {
        return { messageLength: "EMPTY_MESSAGE" };
    }
    return {};
};
